import { useMemo } from 'react'
import { isIosAuthHost } from 'core/auth/shouldUseGoogleRedirect'
import { isRokuTextEntryHost, isTvTextEntryHost } from './isTvTextEntryHost'

export function useTvTextEntry() {
  return useMemo(() => {
    if (typeof navigator === 'undefined') {
      return { isTv: false, isRoku: false, nativeFields: false }
    }
    const userAgent = navigator.userAgent
    const isTv = isTvTextEntryHost(userAgent)
    const isRoku = isRokuTextEntryHost(userAgent)
    return {
      isTv,
      isRoku,
      nativeFields: isTv || isIosAuthHost(),
    }
  }, [])
}
